export default __webpack_public_path__ + "static/media/MODALgarbanzo.806ba66e.png";